import humps from 'humps';

export const camelize = obj => humps.camelizeKeys(obj);

export const camelizeString = str => humps.camelize(str);

export const decamelizeString = string => humps.decamelize(string);

export const capitalize = str => str.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1));



// WEBPACK FOOTER //
// ./src/utils/keysConverter.js